const hasWhiteSpace = (string) => {
    return /\s/g.test(string);
};

const handleCopyToClipboard = (value) => {
    if (value === '') {
        return;
    }
    return navigator.clipboard.writeText(value);
};
const handleCopyToClipboardWithToast = (value) => {
    handleCopyToClipboard(value)
        .then(() => {
            window.sellsyapp.config.globalProperties.$pushToast({
                type: 'success',
                icon: true,
                text: window.sellsyapp.config.globalProperties.$t.__(
                    'common.label.toast_copy_to_clipboard_success',
                ),
            });
        })
        .catch(() => {
            window.sellsyapp.config.globalProperties.$pushToast({
                type: 'error',
                icon: true,
                text: window.sellsyapp.config.globalProperties.$t.__(
                    'common.label.copy_to_clipboard_error',
                ),
            });
        });
};

export { hasWhiteSpace, handleCopyToClipboard, handleCopyToClipboardWithToast };
